import type { FaireThemeEntity } from "../../entity_types/theme";

export const boho_chic_boutique_styles: FaireThemeEntity = {
  token: "boho-chic-boutique-styles",
  type: "theme",
  name: "Boho-Chic Boutique Styles",
  description: "Curated apparel and accessories that blend casual comfort with artisanal flair. Refresh your clothing rack with unique pieces that celebrate individuality.",
  teaser: "Your profile highlights interests in beanies, hoodies, and unique apparel like elephant print pants. You also value 'handmade' and 'artisanal' product signals, which define the boho aesthetic.",
  detail: "The additional_context includes a minimalist knit crop top from Emory Park and spiritual products from Like International, a brand known for its handmade Himalayan and boho-style offerings.",
  bgColor: "#E8D5B7",
  tileBgColor: "#7a6340",
  exactProducts: true,
  retailerToken: "r_31m33roqxk",
  productTokens: [
    "p_x2dvetsmwj",
    "p_yp93d4m4ku",
    "p_606ri0voou",
    "p_un3kt7m35q",
    "p_mjrf83nydx",
    "p_n9q359uxe9",
    "p_pxuw99p8f2",
    "p_4hqrtnf44y",
    "p_f6wrzpfrh8",
    "p_shq7w9zn9b",
    "p_9dn7hrujbc",
    "p_2zt5mz3e45",
    "p_tq9zdg8vd8",
    "p_nkqbfadawr",
    "p_m6k5aswxyw",
    "p_6zpfhgt9eb",
    "p_3ew3m2z58k",
    "p_7h8xjqxrnt",
    "p_5yknracpz6",
    "p_4fw664xbhh",
    "p_ud5bc5crxk",
    "p_4mtg6vqmw4",
    "p_ezjx8qsjp8",
    "p_dqm2t3qehy",
    "p_46myrgpuzw",
    "p_ugrkmaxp4f",
    "p_32h8kpx8yc",
    "p_gwn9m4m2bk",
    "p_2udqmgaagz",
    "p_mxvga2w6vm",
    "p_4awp6wq3b5",
    "p_d9s3ypu7pv",
    "p_cufca9pp6x",
    "p_gbyb8hy4s2",
    "p_maw28tmkej",
    "p_6xvem3urue",
    "p_aggnqmrus4",
    "p_p24sae67j2",
    "p_558pzv49x7",
    "p_bbun7rcy7w",
    "p_equz4cwxhh",
    "p_8ffyn8sqxs",
    "p_y3cz9zj6db",
    "p_4q6pqqdsyx",
    "p_72ferz4xxh",
    "p_gztsyhv8xt",
    "p_9mfrwqxsm8",
    "p_6py347pmkf",
    "p_y755tjwxy3",
    "p_94svn2sh3e",
    "p_sh4wyskke5",
    "p_ya85a3q9cz",
    "p_9ydkbxc542",
    "p_gmbr8f3d6q",
    "p_fmdpzxxk96",
    "p_pfx3gddkz9",
    "p_dk1ph1c8h1",
    "p_byj8dc6ptb",
    "p_nzeudz7sx6",
    "p_7dcqpf7jgh",
    "p_e732kddbu8",
    "p_xmuunp5uzx",
    "p_64nqxsg2gs",
    "p_bddzvedxb9",
    "p_dwfp2t9hhg",
    "p_99et69863t",
    "p_vxvz83rgb6",
    "p_b7vsk67ywt",
    "p_n33msrc88v",
    "p_gcexqdu57f",
    "p_wey62vh3mu",
    "p_kq4b6yxxqp",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-26T00:00:00Z",
    importedBy: "manual-v3-import",
  },
};
